 
import { initializeApp } from "firebase/app";
import {getAuth,GoogleAuthProvider} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyBiuGaLVeMFJtd25CAVDFGn8Vwx5frL_DI",
  authDomain: "topicscounter.firebaseapp.com",
  projectId: "topicscounter",
  storageBucket: "topicscounter.appspot.com",
  messagingSenderId: "774968060408",
  appId: "1:774968060408:web:484d117bba78eb8b6e8e0d"
};

const app = initializeApp(firebaseConfig);
export const auth=getAuth(app);
export const googleProvider=new GoogleAuthProvider();
export const db=getFirestore(app)